import { makeAutoObservable, runInAction, toJS } from 'mobx';
import Local from '@/common/helper/local';
import navbarStore from '@/store/navbar';
import { HelperCore, HelpOther } from "@/common/helper";
import Conf from '@/common/conf';
import client from '@/store/client';
import slsLogger from '@public/log/sls';
import { request } from '@/common';
import { AssistantType } from '@shared/constants/chat';

const lastKnowledgeRoleIdKey = "MODEL_CHOICE_LAST_KNOWLEDGE_ROLE_ID";

class Store {
  list = [];
  curId = null;

  initReady = false;
  initReadyCallback = [];

  get modelInfo () {
    if(!this.curId){
      return null;
    }
    if(this.curId.includes("_")){
      const [roleId, knModelId] = this.curId.split("_");
      return this.list.find(item => item.id == roleId && item.kn_custom_model?.id == knModelId);
    }

    return this.list.find(item => item.id == this.curId);
  }

  constructor() {
    makeAutoObservable(this);
    this.init();
    this.getData();

    if (!HelperCore.IS_PROD) {
      window._knowledgeModelSelectStore = this;
    }
  }

  init () {
    window.addEventListener('message', event => {
      const { origin, source, data:eventData } = event;
      const { action, data } = eventData || {};

      switch(action){
        case "_wsClientMsg":{
          try{
            window._wsClientMsg(data);
          } catch(e){}
          break;
        }
        case "_wsAPIClientMsg":{
          try{
            window._wsAPIClientMsg(data);
          } catch(e){}
          break;
        }
      }
    });
  }

  getData () {
    const roleId = Local.getItem(lastKnowledgeRoleIdKey);
    if(roleId){
      this.curId = roleId;
    }
  }

  switchCurId = id => {
    runInAction(() => {
      this.curId = id;
    });
  };

  updateKownledgeList () {
    const urlParams = HelperCore.getParams();
    // 卫士本地页面调试，没有一级纳米页面，不请求本地、API 模型
    const isWsTest = urlParams["chat-debug"] == 1 && !HelperCore.IS_ONLINE;

    Promise.all([
      navbarStore.getSpecifyModel(Conf.roleIds.knowledge)
      .then(() => {
        if(!navbarStore.chatModels[Conf.roleIds.knowledge]){
          return [];
        }
        return [navbarStore.chatModels[Conf.roleIds.knowledge]]
      })
      .catch(() => {
        return [];
      }),
      ...(
        isWsTest
        ? [
          Promise.resolve([]),
          Promise.resolve([]),
        ]
        : [
          new Promise((resolve) => {
            window.addEventListener('message', event => {
              const { origin, source, data:eventData } = event;
              const { action, data } = eventData || {};

              if(action == "sendLocalList"){
                slsLogger.log({
                  key : "postMessage",
                  ext : JSON.stringify(data),
                  ext1 : origin,
                });
                try{
                  const list = JSON.parse(data);
                  resolve(list);
                } catch(e){}
              }
            });

            window.top.postMessage({
              action : "getLocalList",
            }, "*");
          }),
          request.get('/robot/platform', {
            params: {
              chat_type: 10
            },
          })
          .then(res => {
            const list = res.data?.list || [];
            const customAIbots = list.filter(item => [AssistantType.APIModel, AssistantType.PrivateModel].includes(item.chat_type));
            return customAIbots;
          })
          .catch(() => {
            return [];
          }),
        ]
      ),
      request.get("/knowledge/model/list")
      .then(res => {
        const { data } = res;
        return data.list.map(item => {
          return {
            ...item,
            ...{
              id : Conf.roleIds.knowledge,
              kn_custom_model : item,
            },
          }
        });
      })
      .catch(() => {
        return [];
      }),
    ])
    .then((res) => {
      const [modelList, localList, apiList, knModelList] = res;
      navbarStore.setChatModels(localList);
      navbarStore.setChatModels(apiList);
      const list = []
        // .concat(modelList)
        .concat(knModelList)
        .concat(localList)
        .concat(apiList)
      runInAction(() => {
        this.list = list;
      });
    })
    .finally(() => {
      this.checkCurId();
    })
  }

  checkCurId () {
    runInAction(() => {
      if(!this.list.find(item => item.id == this.curId) || !this.curId){
        this.curId = Conf.roleIds.knowledge;
      }
    });
    this.initReady = true;
    this.doInitReady();
  }

  whenInitReady (fn = () => {}) {
    if(this.initReady){
      try{
        fn();
      } catch(e){}
    }
    else {
      this.initReadyCallback.push(fn);
    }
  }
  doInitReady () {
    if(this.initReadyCallback.length){
      this.initReadyCallback.forEach(fn => {
        try{
          fn();
        } catch(e){}
      });
      this.initReadyCallback = [];
    }
  }

  supportRole (roleId) {
    return !!this.list.find(item => item.id == roleId);
  }
}

const knowledgeModelSelectStore = new Store();
export default knowledgeModelSelectStore;
